import { motion } from "framer-motion";
import { ShieldCheck, Award, Building2, Users } from "lucide-react";

const items = [
  { icon: Users, k: "100+", v: "Indian Families" },
  { icon: Award, k: "18+ yrs", v: "Asset Management" },
  { icon: ShieldCheck, k: "AMFI · IRDAI", v: "Licensed" },
  { icon: Building2, k: "QPFP", v: "Certified Planner" },
];

export default function StatsRibbon() {
  return (
    <section data-testid="stats-ribbon" className="relative bg-[#0B1B3D] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-10 grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
        {items.map((it, i) => (
          <motion.div
            key={it.v}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="flex items-center gap-4 lg:justify-center"
          >
            <it.icon className="w-7 h-7 text-[#10B981]" />
            <div>
              <div className="big-number text-2xl md:text-3xl">{it.k}</div>
              <div className="overline text-[10px] text-white/60">{it.v}</div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
